import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

const getSuccessMessageModalDeviceWidth = (deviceType: DeviceType): string => {
  if (deviceType === "mobile") return "calc(100% - 10px);";
  return "362px";
};

export const SuccessMessageWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  width: ${({ deviceType }) => getSuccessMessageModalDeviceWidth(deviceType)};
  height: auto;
  background: white;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
`;

// Backward compatibility (deprecated)
export const InsuranceMessageWrapper = SuccessMessageWrapper;

export const SuccessContainer = styled.div`
  text-align: center;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconContainer = styled.div`
  margin-bottom: 24px;
`;

export const StyledIcon = styled(FontAwesomeIcon)<{ $iconColor: string }>`
  font-size: 24px;
  color: ${({ $iconColor }) => $iconColor};
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.greyBase};
  text-align: center;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  margin-bottom: 24px;
  text-align: center;
  line-height: 1.5;
  color: ${({ theme }) => theme.greyMedium};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 300px;
`;
